"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledCell = exports.splitHighlights = exports.getCellValue = exports.defaultSortableHeader = exports.defaultHeader = exports.defaultColumnDef = void 0;
var _Cell = require("../../cell/Cell.styled");
var _react = _interopRequireDefault(require("react"));
var _SortableHeaderCell = _interopRequireDefault(require("../../../../../components/data-display/table/column/support/SortableHeaderCell"));
var _IconTooltip = _interopRequireDefault(require("../../../../../components/feedback/tooltip/IconTooltip"));
var _filtersWithHighlighting = require("../../sorting/filtersWithHighlighting");
var _jsxRuntime = require("react/jsx-runtime");
var styledCell = function styledCell(props, value) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell.StyledCell, {
    align: props.align,
    children: value
  });
};
exports.styledCell = styledCell;
var instanceOfSortableColumn = function instanceOfSortableColumn(_o) {
  return true;
};
var defaultColumnDef = function defaultColumnDef(props, exportFormatter, excludeFromExport) {
  var id = props.id,
    header = props.header,
    exportHeader = props.exportHeader,
    hideHeader = props.hideHeader,
    groupingValue = props.groupingValue,
    width = props.width,
    visible = props.visible,
    dataCy = props['data-cy'],
    enableGlobalFilter = props.enableGlobalFilter;
  var isSortable = instanceOfSortableColumn(props) && props.allowSorting;
  return {
    id: id,
    meta: {
      header: header,
      exportHeader: exportHeader,
      hideHeader: hideHeader,
      exportFormatter: exportFormatter || props.exportFormatter,
      width: width,
      visible: visible,
      dataCy: dataCy,
      excludeFromExport: excludeFromExport
    },
    getGroupingValue: groupingValue ? function (row) {
      return groupingValue(row);
    } : undefined,
    header: hideHeader ? undefined : isSortable ? defaultSortableHeader(props) : defaultHeader(props),
    enableGlobalFilter: enableGlobalFilter
  };
};
exports.defaultColumnDef = defaultColumnDef;
var defaultSortableHeader = function defaultSortableHeader(props) {
  var align = props.align,
    header = props.header,
    allowSorting = props.allowSorting;
  if (allowSorting) {
    return function (_ref) {
      var column = _ref.column;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SortableHeaderCell.default, {
        column: column,
        align: align,
        onSortChange: props.onSortChange,
        children: header
      });
    };
  } else {
    return defaultHeader(props);
  }
};
exports.defaultSortableHeader = defaultSortableHeader;
var defaultHeader = function defaultHeader(props) {
  var align = props.align,
    header = props.header,
    headerTooltip = props.headerTooltip;
  return function () {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Cell.StyledCell, {
      align: align,
      children: [header, headerTooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconTooltip.default, {
        iconSize: 'm',
        children: headerTooltip
      })]
    });
  };
};
exports.defaultHeader = defaultHeader;
var splitHighlights = function splitHighlights(value, ranges) {
  if (value === undefined) {
    return undefined;
  }
  var lastRange = value.slice(ranges.length > 0 ? ranges[ranges.length - 1][_filtersWithHighlighting.HIGHLIGHT_RANGE_END] : 0);
  return [].concat(_toConsumableArray(ranges.map(function (range, index, array) {
    var spanRange = value.slice(index > 0 ? array[index - 1][_filtersWithHighlighting.HIGHLIGHT_RANGE_END] : 0, range[_filtersWithHighlighting.HIGHLIGHT_RANGE_START]);
    var markRange = value.slice(range[_filtersWithHighlighting.HIGHLIGHT_RANGE_START], range[_filtersWithHighlighting.HIGHLIGHT_RANGE_END]);
    return [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: spanRange
    }, "span-".concat(range[_filtersWithHighlighting.HIGHLIGHT_RANGE_START], "-").concat(range[_filtersWithHighlighting.HIGHLIGHT_RANGE_END])), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell.Highlight, {
      children: markRange
    }, "mark-".concat(range[_filtersWithHighlighting.HIGHLIGHT_RANGE_START], "-").concat(range[_filtersWithHighlighting.HIGHLIGHT_RANGE_END]))];
  })), [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    children: lastRange
  }, "span-last")]);
};
exports.splitHighlights = splitHighlights;
var getCellValue = function getCellValue(value, cellProps) {
  var globalFilter = cellProps.table.getState().globalFilter;
  // If its an object it is a GlobalFilterWithHighlightingConfig, and we need to do highlighting
  if (typeof globalFilter === 'object') {
    return splitHighlights(value, (0, _filtersWithHighlighting.getHighlightRanges)(cellProps));
  } else {
    return value;
  }
};
exports.getCellValue = getCellValue;